<template>
    <div class="page bg-gray page-flex" :class="canOperate?'pb-fixed-flex-bot':''">
        <backTitleBar></backTitleBar>
        <div class="bg-fff pd-025">
            <div class="flex pd-250 fs-32 bd-bot">
                <div class="flex1 color-333">{{entity.shopName}}</div>
                <div class="color-org">货道 {{entity.wayCode}}</div>
            </div>
            <div class="flex-between fs-28 color-333 pd-250">
                <div>补货人：{{entity.linkName}}</div>
                <div>{{entity.operateTime}}</div>
            </div>
        </div>
        <div class="flex1 posi-rel pd-025 pb-25 scroll-view">
            <div v-for="(userOrder,userOrder$index) in entity.userOrderInfoVOList">
                <div class="card mt-20 pd-25" v-for="(order,$orderIndex) in userOrder.orderInfoVo" :key="$orderIndex" v-if="entity.userOrderInfoVO">
                    <div class="fs-28 font-bold color-333 mb-10">收货人：{{order.userName}}  <span class="ml-10">{{order.userMobile}}</span></div>
                    <div class="fs-24 color-999">订单号：{{order.orderNo}}</div>
                    <div class="list">
                        <div class="flex mt-30" v-for="(prod,$prodIndex) in order.productList" :key="$prodIndex">
                            <div class="item-img mr-20">
                                <img :src="prod.imgPathView" alt="">
                            </div>
                            <div class="flex1">
                                <div class="fs-28 color-000">{{prod.productName}}</div>
                                <div class="fs-24 color-999 mt-15">x{{prod.productQty}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed-flex-bot" v-if="canOperate">
            <div class="flex-btn click" @click="openDoor">取货</div>
            <div class="flex-btn active ml-10 click" @click="replenishOrder">补货</div>
        </div>

        <van-popup v-model="popupShow" position="bottom" :lazy-render="false" :style="{ height: '80vh' }">
            <div class="popup-container">
                <div class="title fs-34 text-center pd-200">请选择要解绑的订单</div>
                <div class="flex1 posi-rel pd-025 pb-25 scroll-view bg-gray">
                    <div v-for="(userOrder,userOrder$index) in entity.userOrderInfoVOList">
                        <div class="card mt-20 pd-25 posi-rel" v-for="(order,$orderIndex) in userOrder.orderInfoVo" :key="$orderIndex" v-if="entity.userOrderInfoVO" @click="chooseOrder(userOrder$index,$orderIndex)">
                            <div class="fs-28 font-bold color-333 mb-10">收货人：{{order.userName}}  <span class="ml-10">{{order.userMobile}}</span></div>
                            <div class="fs-24 color-999">订单号：{{order.orderNo}}</div>
                            <div class="list">
                                <div class="flex mt-30" v-for="(prod,$prodIndex) in order.productList" :key="$prodIndex">
                                    <div class="item-img mr-20">
                                        <img :src="prod.imgPathView" alt="">
                                    </div>
                                    <div class="flex1">
                                        <div class="fs-28 color-000">{{prod.productName}}</div>
                                        <div class="fs-24 color-999 mt-15">x{{prod.productQty}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="choose-icon alifont" :class="order.isChoose ?'color-main icon-xuanzhong':'icon-weixuanzhong color-999'"></div>
                        </div>
                    </div>
                </div>
                <div class="cancel-btn click" @click="cancelBindOrder">取消绑定</div>
            </div>
        </van-popup>

    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {qryWayOrderInfoByWayId,openDoorForLocker,cancelBindOrderV3} from '@/api/shop'
    import {getToken} from "@/utils/util"
    export default {
        name: "lockerOrderDetail",
        components:{backTitleBar},
        data(){
            return{
                wayId:null,
                entity:{
                    userOrderInfoVO:{
                        orderInfoVo:[]
                    }
                },
                canOperate:false,
                popupShow: false,
            }
        },
        created() {
            this.wayId = this.$route.query.wayId;
            this.canOperate = this.$route.query.canOperate || false;
            this.getDetail();
        },
        methods:{
            getDetail(){
                let params = {
                    wayId: this.wayId,
                    orderTypeIn: '5,10'
                }
                qryWayOrderInfoByWayId(params).then(res=>{
                    if(res.code == 0){
                        this.entity = res.data
                    }
                })
            },

            //开门
            openDoor(){
                let _this = this;
                this.$dialog.alert({
                    title: "提示",
                    message: "确定要开门吗?",
                    showCancelButton: true
                })
                    .then(() => {     //点击确认按钮后的调用
                        let params = {
                            accessToken:getToken(),
                            shopId: _this.entity.shopId,
                            wayId: _this.wayId,
                            operateType: 3         //0 寄存开门 1取货开门 2补货开门 3只开门
                        }
                        openDoorForLocker(params).then(res=>{
                            if(res.code == 0){
                                _this.$dialog.alert({
                                    title:'提示',
                                    message:'开门成功',
                                }).then(()=>{
                                    _this.popupShow = true;
                                    // _this.$router.go(-1);
                                })
                            }
                        })
                    })
                    .catch(() => { //点击取消按钮后的调用
                        console.log("cancel")
                    })
            },
            //补货开门
            replenishOrder(){
                let params = {
                    accessToken:getToken(),
                    shopId: this.entity.shopId,
                    wayId: this.wayId,
                    operateType:2
                }
                openDoorForLocker(params).then(res=>{
                    if(res.code == 0){
                        this.$toast("补货开门成功");
                    }
                })
            },

            //选中订单
            chooseOrder(userOrder$index,$orderIndex){
                this.$set(this.entity.userOrderInfoVOList[userOrder$index].orderInfoVo[$orderIndex],'isChoose',!this.entity.userOrderInfoVOList[userOrder$index].orderInfoVo[$orderIndex].isChoose)
            },
            cancelBindOrder(){
                let _this = this;
                this.$dialog.alert({
                    title: "提示",
                    message: "确定要解绑选中订单吗?",
                    showCancelButton: true
                }) .then(() => {     //点击确认按钮后的调用
                        let array = [];
                        _this.entity.userOrderInfoVOList.forEach(userOrderItem=>{
                            if(userOrderItem.orderInfoVo && userOrderItem.orderInfoVo.length > 0 ){
                                userOrderItem.orderInfoVo.forEach(order=>{
                                    if(order.isChoose){
                                        array.push(order.orderId)
                                    }
                                })
                            }
                        })
                        let params = {
                            cancelOrderIds: array,
                            wayId: _this.entity.wayId
                        }
                        cancelBindOrderV3(params).then(res=>{
                            if(res.code == 0){
                                _this.$toast("操作成功");
                                _this.getDetail();
                                _this.popupShow = false;
                            }
                        })
                    })
                    .catch(() => { //点击取消按钮后的调用
                        console.log("cancel")
                    })
            },
        }
    }
</script>

<style scoped lang="scss">
    .item-img{
        width: 1.26rem;
        height: 1.26rem;
    }
    .choose-icon{
        position: absolute;
        top: .25rem;
        right: .25rem;
        font-size: .44rem;
    }
    .cancel-btn{
        text-align: center;
        border-radius: .12rem;
        line-height: .74rem;
        font-size: .3rem;
        background: $main-color;
        color: #fff;
        margin: .2rem;
    }
    .popup-container{
        display: flex;
        flex-direction: column;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// lockerOrderDetail.vue?007fa89d